import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import {
  MatDialogRef,
  MatDialog,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { Subscription } from "rxjs";
import { MixinFunctionsService } from "src/app/pages/services/mixin-functions.service";
import { LoanApplicationService } from "../loan-application.service";

@Component({
  selector: "app-loan-application-status",
  templateUrl: "./loan-application-status.component.html",
  styleUrls: ["./loan-application-status.component.scss"],
})
export class LoanApplicationStatusComponent implements OnInit, OnDestroy {
  subs: Subscription[] = [];
  loanApplicationStatus: any = [];
  constructor(
    public dialogRef: MatDialogRef<LoanApplicationStatusComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public formData: any,
    public mixins: MixinFunctionsService,
    private loanApplication: LoanApplicationService
  ) {}

  ngOnInit(): void {
    this.getLoanApplicationStatus(this.formData);
  }
  ngOnDestroy(): void {
    if (this.subs) {
      this.subs.forEach((sub) => sub.unsubscribe());
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getLoanApplicationStatus(params) {
    const payload = {
      loanApplicationId: params.id,
    };
    this.subs.push(
      this.loanApplication
        .viewLoanApplicationStatus(payload)
        .subscribe((response) => {
          if (response.code === 200 && response.data !== null) {
            this.loanApplicationStatus = response.data.map((item, index) => ({
              step: response.data.length - index,
              ...item,
              canSeeMessage: this.canSeeMessage(item),
            }));
            // this.formData.canRespond = this.canRespond(
            //   response.data[0].loanApplication.toBeRespondendedBy
            // );
          }
        })
    );
  }

  canSeeMessage(loan) {
    if (this.mixins.currentUser.position.name.toLowerCase() === "group admin") {
      //we show only comments from CDO or those created by Group Admin only
      if (
        loan.loanApplication.rejectedByCdo === true ||
        loan.createdBy.position.name.toLowerCase() === "group admin"
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
}
